import { useMemo } from 'react';
import { GroupedOptionsConfig } from 'src/core/POS/PosMultiSelect/PosMultiSelect.types';
import { ContentId } from 'src/utils/constants/contentId';
import {
  STUBHUB_PARENT_CATEGORY_GROUPS,
  STUBHUB_PARENT_CATEGORY_TO_CID,
} from 'src/utils/constants/contentIdMaps';

export type ParentCategoryToCidResult = {
  /** The flat map of category IDs to ContentIds */
  map: Record<string, ContentId>;
  /** Optional grouped configuration for displaying categories in sections */
  groupedConfig?: GroupedOptionsConfig;
};

/**
 * Returns the parent category to ContentId map with StubHub sub-genres.
 *
 * Returns STUBHUB_PARENT_CATEGORY_TO_CID which:
 * - Replaces generic sport types (Baseball, Basketball, American Football) with league-specific categories (MLB, NBA, NFL)
 * - Adds new categories: NHL, MLS, Tennis, F1, Rugby, Horse Racing, Cricket, WWE, Volleyball
 * - Adds new concert categories: Pop, Heavy Metal, Funk, Experimental
 * - Includes grouped configuration for sectioned dropdown display
 */
export const useParentCategoryToCid = (): ParentCategoryToCidResult => {
  return useMemo(
    () => ({
      map: STUBHUB_PARENT_CATEGORY_TO_CID,
      groupedConfig: STUBHUB_PARENT_CATEGORY_GROUPS,
    }),
    []
  );
};
